import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

export const useListBrowserFunctions = () => {
  const { t } = useTranslation();

  const textResolver = useCallback(
    ({ type, caption }) => {
      if (type) return t(`ListBrowser.${type}`);
      if (caption) return t(caption);
      return '';
    },
    [t]
  );

  return { textResolver };
};
